const vconst = {

    prodActive : 1,
    prodArchive: 0,
 
    // Статуси лідів - заявок
    leadNew : 0,
    leadInWoork : 100,
    leadNeedOffer : 200,
    leadNeedsAttention : 250,
    leadOffer : 300,
    leadPostponed : 350,
    leadAccept : 400,
    leadReject : -1,
 
    // Статути об'єктів
    objectAllStatuses : [0,1,99,100,-1],
    objectPanding       : 0,
    objectInWork        : 1,
    objectFinishedTeam  : 99,
    objectFinished      : 100,
    objectReject        : -1,

    // Статуси оплати об'єкта
    objectPayUnpaid     : 0,
    objectPayPartial    : 1,
    objectPayPaid       : 2,

    waherouseMainId : 1,
    waherouseWriteOffId : 1000,

    operStatApproved : 1,
    operStatPandings : 0,
    operStatReversal : -1,

    incomeStatActive : 1,
    incomeStatCancel : -1,
 
    
    bgRowOperStat : {
        '1' : '',
        '-1': 'bg-light-danger',
        '0' : 'bg-light-warning'
    },

    bgRowExpendStat : {
        '1' : 'bg-light-success',
        '-1': 'bg-light-danger',
    },
    
    expendTypeDefIncome : 5,
    expendTypeDefExpend : 7,
    
    expendMarketingId : 1,
    expendAddProductId : 4,
} 


export default vconst; 